// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JqM7","placeholdersHeader":"styles_placeholdersHeader__nT6Ad","editorStyle":"styles_editorStyle__3Zce0","placeholdersBox":"styles_placeholdersBox__1vmWA"};